import { Button, Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import DataTable, { TableColumn } from "react-data-table-component";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from "react";
import { SearchTableButton } from "../../../../utils/Constant";
import api from "../../../../utils/api";
import { AllFoodOrderTableDataColumnType } from "../../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import { SVG } from "../../../../AbstractElements";
import AllFoodOrderFilterHeader from "../../../../Componant/Application/Ecommerce/ProductList/AllFoodOrderFilterHeader";
import { AllFoodOrderTableAction, AllFoodOrderTableProductName, AllFoodOrderTableStatus } from "../../../../Data/Application/Ecommerce/AllFoodOrder";
import { useNavigate } from "react-router-dom";

const AllFoodOrderContainer = () => {
  const navigate = useNavigate();
  const [filterText, setFilterText] = useState("");
  const [foodOrderTableDatas, setFoodOrderTableDatas] = useState([]);
  const [transactionModalOpen, setTransactionModalOpen] = useState(false);
  const [orderData, setOrderData] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const fetchAllFoodOrder = async (page: number, size: number) => {
    setLoading(true);
    try {
      const response = await api.get(`/api/FoodOrder/GetAllFoodOrderItemPagination?pageNumber=${page}&pageSize=${size}`);
      if (response.status === 200) {
        setFoodOrderTableDatas(
          response.data.items.map(
            (item: any): AllFoodOrderTableDataColumnType => ({
              foodOrderId: item.foodOrderId,
              subTotalAmount: item.subTotalAmount,
              gst: item.gst,
              grandTotalAmount: item.grandTotalAmount,
              status: item.status,
              ticketRFIdRef: item.ticketRFIdRef,
              cardNumber: item.cardNumber,
            })
          )
        );
        setTotalRows(response.data.totalCount);
      }
    } catch (error) {
      //   console.error("Failed to fetch food order:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAllFoodOrder(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const handleDelete = async (id: number) => {
    try {
      await api.put(`/api/FoodOrder/UpdateFoodOrderStatus?foodOrderId=${id}`);
      Swal.fire('Update!', 'Status has updated successfully!!.', 'success');

      // Optional: refresh the list
      //   setCardAssignTableDatas((prev) => prev.filter((item: { adultPlanId: any; }) => item.adultPlanId !== id));
    } catch (error) {
      Swal.fire('Error!', 'Failed to update order status.', 'error');
      // console.error("Return error:", error);
    }
    await fetchAllFoodOrder(currentPage, pageSize);
  };

  const handleViewTransaction = async (foodOrderId: any) => {
    try {
      const response = await api.get(
        `/api/FoodOrder/GetAllFoodOrderDetailsById?foodOrderId=${foodOrderId}`
      );
      if (response.status === 200) {
        setOrderData(response.data);
        setTransactionModalOpen(true);
      } else {
        Swal.fire("Error!", "Failed to fetch food order details.", "error");
      }
    } catch (error) {
      Swal.fire("Error!", "Failed to fetch food order details.", "error");
      // console.error("food order details fetch error:", error);
    }
  };

  const allFoodOrderTableDataColumn: TableColumn<AllFoodOrderTableDataColumnType>[] = [
    {
      name: "Ticket Number",
      cell: (row) => <AllFoodOrderTableProductName title={row.ticketRFIdRef} />,
      sortable: true,
      grow: 6,
    },
    {
      name: "RFID Card No.",
      selector: (row) => `${row.cardNumber}`,
      sortable: true,
      grow: 6,
    },
    {
      name: "Total Amount",
      selector: (row) => `${row.subTotalAmount}`,
      sortable: true,
      grow: 6,
    },
    {
      name: "GST",
      selector: (row) => `${row.gst}`,
      sortable: true,
      grow: 4,
    },
    {
      name: "Grand Total Amount",
      selector: (row) => `${row.grandTotalAmount}`,
      sortable: true,
      grow: 6,
    },
    {
      name: "Status",
      cell: (row) => <AllFoodOrderTableStatus title={row.status} />,
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span
            className="cursor-pointer bg-danger text-white p-2 rounded"
            title="Print Order"
            style={{ marginRight: 4, cursor: "pointer" }}
            onClick={() => {
              navigate(`/print-food-order/${row.foodOrderId}`);
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 8V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v2H3v8h4v4h10v-4h4V8h-2zm-2 10H7v-4h10v4zm2-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-2-4H7V6h10v2z" />
            </svg>
          </span>
          <span
            onClick={() => handleViewTransaction(row.foodOrderId)}
            title="View food order item"
            style={{ cursor: "pointer", marginLeft: "8px", marginRight: "8px" }}
            className="cursor-pointer bg-primary text-white p-2 rounded"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
            </svg>
          </span>
          <AllFoodOrderTableAction foodOrderId={row.foodOrderId} onDelete={handleDelete} />
        </>
      ),
      grow: 6,
    },
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };

const filteredItems = foodOrderTableDatas.filter((item: any) => {
    if (!filterText) return true;
    const search = filterText.toLowerCase();
    return Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(search)
    );
});

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFilterText(e.target.value)
          }
          type="search"
          value={filterText}
        />
      </div>
    );
  }, [filterText]);

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <AllFoodOrderFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable
                    data={filteredItems}
                    columns={allFoodOrderTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationDefaultPage={currentPage}
                    paginationPerPage={pageSize}
                    progressPending={loading}
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        isOpen={transactionModalOpen}
        toggle={() => setTransactionModalOpen(false)}
        size="xl"
        style={{
          maxWidth: "90vw",
          width: "90vw",
          minHeight: "70vh",
          top: "5vh",
        }}
        contentClassName="custom-transaction-modal"
      >
        <ModalHeader
          toggle={() => setTransactionModalOpen(false)}
          style={{
            fontSize: "2rem",
            fontWeight: 700,
            borderBottom: "2px solid #eee",
            background: "#f0f4f8",
            color: "#222",
            letterSpacing: 1,
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <SVG
              iconId="credit-card"
              style={{ width: 32, height: 32, fill: "#007bff" }}
            />
            Food Order Item
          </span>
        </ModalHeader>
        <ModalBody
          style={{
            padding: "2.5rem 2rem 2rem 2rem",
            background: "#f8f9fa",
            minHeight: "60vh",
            overflowY: "auto",
          }}
        >
          {orderData ? (
            Array.isArray(orderData) ? (
              orderData.length > 0 ? (
                <div className="row g-4">
                  {orderData.map((txn: any, idx: number) => (
                    <div key={idx} className="col-md-6 col-lg-4 mb-4">
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: 18,
                          boxShadow: "0 4px 24px #0002",
                          padding: 28,
                          height: "100%",
                          border: "1px solid #e3e6ea",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: 16,
                          }}
                        >
                          <SVG
                            iconId="file-text"
                            style={{
                              width: 22,
                              height: 22,
                              fill: "#007bff",
                              marginRight: 8,
                            }}
                          />
                          <h5
                            style={{ margin: 0, fontWeight: 700, fontSize: 18 }}
                          >
                            Item Name: {txn.foodItemName}
                          </h5>
                        </div>
                        <div style={{ fontSize: 15, color: "#444" }}>
                          <p style={{ marginBottom: 8 }}>
                            <b>Quantity:</b> {txn.quantity}
                          </p>
                          <p style={{ marginBottom: 8 }}>
                            <b>Amount:</b>{" "}
                            <span style={{ color: "#007bff", fontWeight: 600 }}>
                              ₹{txn.price}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p style={{ textAlign: "center", color: "#888", fontSize: 18 }}>
                  No Order Item found.
                </p>
              )
            ) : (
              <div
                style={{
                  background: "#fff",
                  borderRadius: 18,
                  boxShadow: "0 4px 24px #0002",
                  padding: 32,
                  maxWidth: 500,
                  margin: "0 auto",
                  border: "1px solid #e3e6ea",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 16,
                  }}
                >
                  <SVG
                    iconId="file-text"
                    style={{
                      width: 22,
                      height: 22,
                      fill: "#007bff",
                      marginRight: 8,
                    }}
                  />
                  <h5 style={{ margin: 0, fontWeight: 700, fontSize: 18 }}>
                    Item Name: {orderData.foodItemName}
                  </h5>
                </div>
                <div style={{ fontSize: 15, color: "#444" }}>
                  <p style={{ marginBottom: 8 }}>
                    <b>Quantity:</b> {orderData.quantity}
                  </p>
                  <p style={{ marginBottom: 8 }}>
                    <b>Amount:</b>{" "}
                    <span style={{ color: "#007bff", fontWeight: 600 }}>
                      ₹{orderData.price}
                    </span>
                  </p>
                </div>
              </div>
            )
          ) : (
            <p style={{ textAlign: "center", color: "#888", fontSize: 18 }}>
              No data found.
            </p>
          )}
        </ModalBody>
        <ModalFooter
          style={{ borderTop: "2px solid #eee", background: "#f0f4f8" }}
        >
          <Button
            color="secondary"
            size="lg"
            style={{
              minWidth: 120,
              borderRadius: 8,
              fontWeight: 600,
              fontSize: 18,
            }}
            onClick={() => setTransactionModalOpen(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

export default AllFoodOrderContainer;
